import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders  } from '@angular/common/http';
import * as theGlobals from '../shared/globals';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { PrintGuidDto } from '../shared/dto/PrintGuidDto';
import * as XLSX from 'xlsx';
@Injectable()

export class UtilitiesService {
    constructor(private datePipe: DatePipe, private http: HttpClient, private cookieService: CookieService) { }

    private myUrl = theGlobals.setEnv().funcUrl;
    private myAuditFlag = theGlobals.setEnv().auditFlag;
    private eFileParodanUrl = theGlobals.setEnv().eFileParodanUrl;
    private sbProdEfile = theGlobals.setEnv().sbProdEfile;
  //
    private myUserCreds = {
        userName: '',
        isValidated: false,
    };
    private mySecurityLevel = 99;

    // utility functions
    convertDateToDays(myDate: Date): number {
        const tDate = new Date(myDate);
        const myYear = tDate.getFullYear();
        const myMonth = tDate.getMonth();
        const myDay = tDate.getDate();
        const numLeapYears = this.calcNumLeapYear(myYear - 1);
        const intDate = (myYear * 365) + numLeapYears + this.calcNumDays(myYear, myMonth, myDay);
        return intDate;
    }

    // calculate the number of Leap years that have occured since specified year
    calcNumLeapYear(myDate: number): number {
        let numHits = 0;
        for (let x = 1; x < myDate; x++) {
            if (x % 4 === 0) { numHits++; }
        }
        return numHits;
    }

    // determine if the specified year qualifies as a Leap Year
    isLeapYear(myYear: number): boolean {
        if (myYear % 4 === 0) {
            return true;
        } else {
            return false;
        }
    }

    // calculate the # of days since the beginning of the year
    calcNumDays(myYear: number, myMonth: number, myDay: number): number {
        const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (this.isLeapYear(myYear)) {
            daysInMonth[1] = 29;  // account for leap years
        }
        let netDays = 0;
        for (let mo = 0; mo < myMonth; mo++) {
            netDays = netDays + daysInMonth[mo];
        }
        return netDays + myDay;
    }

    // encrypt the specified key/id
    genEncryptId(myKey: string): string {
        // not currently being used 3/21/2022
        let t = '';
        let t1 = '';
        let i: number;
        // var a = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const a = 'ABCLMNopqrstuWXYZ0123456789';
        const b = 'abcdefGHIJK0123456789';

        for (i = 0; i < 15; i++) {
            t += a.charAt(Math.floor(Math.random() * a.length));
        }

        for (i = 0; i < 8; i++) {
            t1 += b.charAt(Math.floor(Math.random() * b.length));
        }
        return t + myKey.toString() + t1;
    }

    // convert an UTC Date to local (timezone-specific) Date; returns a Date object
    convertUTCtoLocal(utcDate: Date): Date {
        // convert offset minutes to hours; NOTE: a positive value -> TimeZone is BEHIND of UTC, negative value -> TImezone is AHEAD of UTC; PST offset = 420 minutes (7 hours))
        const offset = new Date().getTimezoneOffset() / 60;
        const utcD = new Date(utcDate).getTime();   // get # of milliseconds since Jan 1 1970 for the specified UTC time
        const nd = new Date(utcD - (3600000 * offset));   // apply offset to new date; this should create be the Local date!
        return nd;
    }

    // Alan's function to format a date (in preparation for filing into DB); assume myDate is a Date object
    convertDateForSaving(myDate): Date {
        const myYear = myDate.getFullYear();
        let myMonth = myDate.getMonth() + 1;
        if (myMonth.toString().length < 2) {
            myMonth = '0' + myMonth;
        }
        let myDay = myDate.getDate();
        if (myDay.toString().length < 2) {
            myDay = '0' + myDay;
        }
        const myNewDate = myYear + '-' + myMonth + '-' + myDay + 'T10:00:00';
        return new Date(myNewDate);
    }

    // format a date (if none provided, default to today/now)
    // Where:   delim = delimeter string (default = '/'), isUTC = is specified date in UTC format(default = false)
    //          incTime = deteremine if a timestamp will also be returned
    formatDate(myDate: any = null, delim: string = '/', isUTC: boolean = false, incTime: boolean = false): string {
        if (myDate == null) {
            myDate = new Date();
        }
        let localDate: Date;
        if (isUTC) {
            localDate = this.convertUTCtoLocal(myDate);
        } else {
            localDate = myDate;
        }
        // this.datePipe.transform(localDate.toString(), 'yyyy-MM-dd hh:mm:ss')
        let myDay = localDate.getDate().toString();
        if (myDay.toString().length < 2) {
            myDay = '0' + myDay;
        }
        let myMo = (localDate.getMonth() + 1).toString();
        if (myMo.length < 2) {
            myMo = '0' + myMo;
        }
        const myYear = localDate.getFullYear();
        let myTime = '';
        if (incTime === true) {
            let myHours = localDate.getHours().toString();
            if (myHours.length < 2) {
                myHours = '0' + myHours;
            }
            let myMins = localDate.getMinutes().toString();
            if (myMins.length < 2) {
                myMins = '0' + myMins;
            }
            let mySecs = localDate.getSeconds().toString();
            if (mySecs.length < 2) {
                mySecs = '0' + mySecs;
            }
            myTime = ' @ ' + myHours + ':' + myMins + ':' + mySecs;

        }
        return myMo + delim + myDay + delim + myYear + myTime;
    }

    // send messages/data to console - iff auditFlag is true
    doAudit(msg: any, headr: string = '') {
        if (this.myAuditFlag) {
            if (headr.length > 0) {
                console.log(headr);
            }
            console.log(msg);
        }
    }
    stripDashes(x) {
        if (x === null || x === undefined) {
            return '';
        }
        return x.toString().replace(/-/g, '');
    }

  getCreatePdfUrlNEW(): string {
    const xURL = this.eFileParodanUrl + '/createapplicationpdf/';
    return xURL;
  }

    // return the URL used to (dynamically) create a PDF of the application
    getCreatePdfUrl(): string {
        let xURL = this.eFileParodanUrl + '/mgmtsiteAccess/createaapdf?id=';
        if (!this.sbProdEfile) {
          // if we're connecting to the NEW E-file system, use this URL instead - rod 12/22/2025
          xURL = this.eFileParodanUrl + '/createapplicationpdf/';
        }
        return xURL;
    }

    getPrintURLToken(): Observable<PrintGuidDto> {
        const xUrl = this.myUrl + '/printsec';
        return this.http.post<any>(xUrl, null);
    }
    // make API call and get back a Blob (document, image, etc)
    getBlob(genUrl: string, useMyUrl: boolean = true): Observable<Blob> {
      let xUrl = '';
      if (useMyUrl) {
        xUrl = this.myUrl + '/' + genUrl;
      } else {
        xUrl = genUrl
      }
      return this.http.get(xUrl,{ responseType: 'blob' });
    }
    // open new Window and populate it w/ specified data (typically a Blob/stream representing a document)
    // see: getBlob method, above
    openNewWindow(data: any): boolean {
      const myUrl = URL.createObjectURL(data);
      window.open(myUrl, '_blank');
      URL.revokeObjectURL(myUrl);
      return true;
    }

    // get PDF (stream) of agenda documents for cases scheduled for selected hearing
    getMergeDocs(hearingId: number): Observable<Blob> {
      // const xUrl = this.myUrl + '/case/hearing/' + hearingId + '/casedocs';
      // switched to agenda API - rod 1/26/2025
      const xUrl = this.myUrl + '/agenda/hearing/' + hearingId + '/casedocs';
      return this.http.get(xUrl,{ responseType: 'blob' });
    }

    // currency/number formatting-elated functions
    // format numeric value with thousand (comma) seperators
    thouSeparator(myNum) {
        // check if myNum is a number??
        if (!myNum) {
        return '';
        } else if (isNaN(myNum)) { return ''; }
        myNum = this.stripCommas(myNum);  // if user entered a number w/ commas, strip them!
        const numParts = myNum.toString().split('.');
        numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return numParts.join('.');
    }

    // strip commas from value (if any)
    //  retNum:
    //      true:   if val = 0, returns 0   [DEFAULT]
    //      false:  if val = 0, returns ''
    stripCommas(aVal: any, retNum: boolean = true): any {
        let cleanVal = 0;
        if (aVal !== null && aVal !== undefined) {
            cleanVal = +aVal.toString().replace(/,/g, '');
        }
        if (retNum) {
          return cleanVal;
        } else {
          return cleanVal === 0 ? '' : cleanVal;
        }
    }

    loginAsync(userName: string, userPwd: string): Observable<any> {
        const xUrl = this.myUrl + '/login/' + userName + '/' + encodeURIComponent(userPwd);
        return this.http.get<any>(xUrl, { headers: this.getCORSHeader()});
    }

    getCORSHeader(): HttpHeaders {
        const headers = new HttpHeaders();

        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');

        // headers.append('Access-Control-Allow-Origin', 'http://localhost:4200');
        // headers.append('GET', 'POST');

        return headers;
    }
    // temp login
    loginSync(userName: string, userPwd: string): string {
        // authenticate the user; for now, hardcode
        const tdy = new Date();
        const day = tdy.getDate();
        // const month = tdy.getMonth() + 1;
        const pwdUser = userPwd.split(';')[0];
        const pwdDay = userPwd.split(';')[1];
        // console.log('day: ' + day);
        if (!pwdUser || !pwdDay) {
            this.myUserCreds.isValidated = false;
            return 'false';
        } else if (userName === pwdUser && day === +pwdDay) {
            this.myUserCreds.userName = userName;
            this.myUserCreds.isValidated = true;
            return 'true';
        } else {
            this.myUserCreds.isValidated = false;
            return 'false';
        }
    }

    isUserValidated(): boolean {
        return true;
        // return this.myUserCreds.isValidated;
    }

    logOff() {
        this.myUserCreds.isValidated = false;
        this.cookieService.delete('userRole', '/');
        this.cookieService.delete('whoami', '/');
        return;
    }

    getUserCreds(): string {
        return this.myUserCreds.userName;
    }

    saveSecLevel(userRole: string)
    {
      // currently defined Roles (hard coded in User component)
      //  CoB:      'Administrator', 'Clerk of the Board', 'ReadOnly'
      //  Assessor: 'Assessor', 'Assessor-Supervisor', 'Assessor-Manager', 'Assessor-ReadOnly'
        let secLevel = 99;
        if (userRole.includes('Assessor-Manager')) {
            secLevel = 11;
        } else if (userRole.includes('Assessor-Supervisor')) {
            secLevel = 12;
        } else if (userRole.includes('Assessor-ReadOnly')) {
            secLevel = 14;
        } else if (userRole.includes('Assessor')) {
            secLevel = 13;
        } else if (userRole.includes('Clerk')) {
            secLevel = 4;
        } else if (userRole.includes('Admin')) {
            secLevel = 1;
        } else if (userRole.includes('ReadOnly')) {
            secLevel = 5;
        }
        this.mySecurityLevel = secLevel;
    }
    getSecLevel() {
        return this.mySecurityLevel;
    }

  isDeveloper(): boolean {
    const myUser = this.cookieService.get('userName').toUpperCase();
    if (myUser.substring(myUser.length - 11) === 'PARODAN.COM') {
      return true;
    } else if (myUser.includes('MESASYSTEMSGROUP')) {
      return true;
    } else if (myUser.substring(0, 16) === 'GERARD_RODRIGUEZ') {
      return true;
    }
    /* else if (myUser.substring(0, 4) === 'ALAND') {
      return true;
    }*/
    return false;
  }
  formatString(strType: string, strVal: string): string
  {
    let retVal = strVal;
    if (strType === 'APN') {
      retVal = retVal.replace(/ /g, ''); // strip out spaces
      if (retVal) {
        retVal = retVal.length === 9? retVal.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3'): strVal
      }
    }
    return retVal;
  }
  exportExcel(myData: any[], myCols: string[], myFileName: string) {
      const worksheet = XLSX.utils.json_to_sheet(myData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const tsNow = new Date();
      const ts = tsNow.getFullYear() + '-' + (tsNow.getMonth() + 1) + tsNow.getDate() + '-' + tsNow.getTime();
      const fileName = myFileName + '_export_' + ts + '.xlsx';

      XLSX.writeFile(workbook, fileName);
  }
  exportExcel2(myData: any[], myCols: any[], myFileName: string) {
    const tsNow = new Date();
    const ts = tsNow.getFullYear() + '-' + (tsNow.getMonth() + 1) + tsNow.getDate() + '-' + tsNow.getTime();
    const fileName = myFileName + '_export_' + ts + '.xlsx';

    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, myCols);

  // Starting in the second row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(ws, myData, {skipHeader: true, origin: 'A2'});
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName);
  }
  checkDBConn(): Observable<any> {
    const xUrl = this.myUrl + '/assessor/dbaccess';
    return this.http.get<any>(xUrl, { headers: this.getCORSHeader()});

  }
  // functions to store data (arrays) in local storage
  setArray(key: string, array: any[]): void {
    localStorage.setItem(key, JSON.stringify(array));
  }

  getArray(key: string): any[] {
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) : [];
  }

  private handleError(err: HttpErrorResponse) {
        // in a real world app, we may send the error to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage = '';
        const status = err.status;
        if (err.error instanceof Error) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
        }
        console.error(errorMessage);
        return Observable.throw(status);
    }

}
